import { PageHeaderWithBack } from "../../../../Components/Molecules";
import { PixTransferContent } from "../PixTransfers/PixTransferContent";

/**
 * Dedicated Pix copia e cola route (`/pix/copia-cola`).
 * Reuses the transfer flow starting in QR mode: paste EMV → decode → review → password → done.
 */
export const PixPayment = () => {
  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-6 sm:px-6">
      <PageHeaderWithBack
        title="Pix copia e cola"
        subTitle="Cole o código EMV, confira o destinatário e conclua o pagamento"
        backTo="/pix"
      />
      <PixTransferContent showGreeting={false} initialTransferMode="qrcode" />
    </div>
  );
};
